<template>
  <div class="login">
    <!-- Header -->
    <div class="py-7 py-lg-8 pt-lg-9">
      <b-container>
        <div class="header-body text-center mb-2">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <img class="img-fluid" src="img/img_logo_white.svg" alt="">
              <p class="mt-3 mb-5">
                Bienvenido al Portal Administrativo
              </p>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
             xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--8 pb-5">
      <b-row class="justify-content-center">
        <b-col lg="5" md="7">
          <p class="error-message" v-if="error">{{error}}</p>
          <validation-observer v-slot="{handleSubmit}" ref="formValidator">
            <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
              <div class="login-field-wrapper">
                <base-input alternative
                  class="mb-3"
                  name="Usuario"
                  :rules="{required: true}"
                  placeholder="Usuario"
                  v-model="model.email">
                </base-input>
                <img src="img/theme/icn_userlogin.svg" alt="">
              </div>

              <div class="login-field-wrapper">
                <base-input alternative
                          class="mb-3"
                          name="Password"
                          :rules="{required: true, min: 4}"
                          type="password"
                          placeholder="Contraseña"
                          v-model="model.password">
                </base-input>
                <img src="img/theme/icn_passlogin.svg" alt="">
              </div>


              <div class="text-center">
                <base-button type="primary" native-type="submit" class="my-4 full-width">Iniciar sesión para registrar mis datos</base-button>
              </div>
            </b-form>
          </validation-observer>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import axios from 'axios'
import qs from 'qs'

  export default {
    data() {
      return {
        model: {
          email: '',
          password: '',
          rememberMe: false
        },
        error: ''
      };
    },
    methods: {
      onSubmit() {
        axios
        .post(
          process.env.VUE_APP_ROUTE_BACKEND_API+'login.php',
          qs.stringify({ user: this.model.email, pass: this.model.password }),
        )
        .then((response) => {
          if (!response.data.error.code && response.data.api_token) {
            localStorage.setItem('token', response.data.api_token)
            localStorage.setItem('id_user', response.data.user.id)
            localStorage.setItem('mail_user', response.data.user.mail)
            localStorage.setItem('name_user', response.data.user.name)
            localStorage.setItem('hospital_user', response.data.user.hospital_id)
            localStorage.setItem('role', response.data.user.role)
            this.$router.push('/')
          } else {
            this.error = response.data.error.code == 2 ? 'Usuario y/o contraseña es incorrecto' : 'Error al intentar iniciar sesión, intente mas tarde.'
          }
        })
        .catch((err) => {
          console.log(err)
        })
      }
    }
  };
</script>
<style scope>
p{
  color: #fff;
}
.full-width{
 width: 100% !important;
}
.login .form-control{
  background: transparent !important;
  border: 1px solid rgba(255,255,255, 0.5) !important;
  border-radius: 3px;
  color: #fff !important;
  padding-left: 45px;
}
.login .form-control::placeholder{
  color: #fff !important;
}
.login-field-wrapper{
  position: relative;
}
.login-field-wrapper img{
  position: absolute;
  top: 12px;
  left: 10px;
}
.error-message{
  color: red;
}
</style>
